"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Ignoring the following line because it only happens once on file inclusion
/* istanbul ignore next */
const context = typeof window === 'object' ? window : global;
function bindToContext(fn) {
    'use strict';
    /* istanbul ignore next */
    return function boundFunction(...args) {
        return fn.apply(context, Array.prototype.slice.call(args));
    };
}
exports.default = {
    clearInterval: bindToContext(clearInterval),
    clearTimeout: bindToContext(clearTimeout),
    now: Date.now,
    setInterval: bindToContext(setInterval),
    setTimeout: bindToContext(setTimeout)
};
//# sourceMappingURL=clock.js.map